var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategoryActivities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0-5.523-4.478-10-10-10C4.474 0 0 4.478 0 10c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10ZM4.956 2.728A8.813 8.813 0 0 1 9.999 1.15c.415 0 .824.028 1.224.084v.82L7.868 3.8H5.28l-.325-1.073ZM4.548 4.09l-.277-.837a8.86 8.86 0 0 0-2.69 4.01l1.363-.608L4.548 4.09ZM3.064 7.532l-1.754.783a8.9 8.9 0 0 0 1.136 6.301l.774-.125 1.25-1.385-.016-3.628-1.39-1.946Zm2.17 2.006.016 3.396 3.063 1.701 2.93-1.579V9.872L7.744 7.91l-2.51 1.629ZM8.227 7.28l3.485 1.957 2.394-1.227.004-3.6-2.575-1.622-3.51 1.826.202 2.666Zm6.662-2.568-.004 3.118 1.607 2.547 2.038-.542.223-1.16A8.823 8.823 0 0 0 16.47 3.96l-1.58.752Zm3.73 5.988.173.32a8.83 8.83 0 0 1-3.23 5.864l-.68-.173.002-2.495 2.07-3.107-.013-.022 1.679-.387Zm-4.52 3.927-2.435-.913-2.948 1.587v1.814l3.464 1.263 1.861-1.253.057-2.498Zm-5.69 3.251H6.454l-.007.23a8.814 8.814 0 0 0 3.554.741c.29 0 .579-.013.863-.041l-2.455-.93Zm-2.724-.516-1.877-2.188-.883.143a8.89 8.89 0 0 0 2.751 2.406l.01-.361Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryActivities);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/category-activities.1cf627cd5b677630e5c6c1b97f63568f.svg";